'use strict';

/* global $ */

import { yaCounter } from '../settings';


class YandexMetrika {
    constructor(options) {
        this.opt = $.extend({}, { yaCounter }, options);
    }
    reachGoal(goal, params) {
        try {
            this.counter.reachGoal(goal, params);
            console.info(`[ YandexMetrika ] Goal ${goal} is reached successfully`);
        } catch (err) {
            console.error(`[ YandexMetrika ] Can't reach goal ${goal}`, err);
        }
    }
    setParams(params) {
        try {
            this.counter.params(params);
            console.info('[ YandexMetrika ] Params are set successfully');
        } catch (err) {
            console.error('[ YandexMetrika ] Can\'t set params', err);
        }
    }
    get counter() {
        if (!this.__counter) {
            this.__counter = window[this.opt.yaCounter];
        }
        return this.__counter;
    }
}

let yandexMetrika = new YandexMetrika();


export {
    yandexMetrika
};
